export default {"src":"/_next/static/media/ReviewsIoLogoWhite.dd755419.svg","height":21,"width":121,"blurWidth":0,"blurHeight":0};